import React from 'react';
import { IChangePassword } from '../../api/ApiClient';
import { Card } from 'components';
import { IRootState, Dispatch } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import styles from './ProfileContainer.module.scss';
import ProfileInfoBlock from 'components/ProfileInfoBlock/ProfileInfoBlock';

const ProfileContainer = ({
    auth,
    apiError,
    changePassword,
    updatePhone,
    sendUpdatePhoneVerificationCode,
    checkUpdatePhoneVerificationCode,
}: Props) => {
    const changePass = async (data: IChangePass) => {
        let res: boolean | null = null;
        if (data.oldPassword) {
            const nData = data as IChangePassword;
            res = await changePassword(nData);
        }

        return res;
    };

    const title = auth && auth.profile ? `${auth.profile.lastName} ${auth.profile.firstName}` : '';

    return (
        <Card
            borderedTitle
            title={title}
            contentClassName={styles.profile__container}
            apiError={apiError}
            showLoader={!auth || !auth.profile}
        >
            {auth ? (
                <ProfileInfoBlock
                    profile={auth.profile}
                    apiError={apiError}
                    onChangePassword={changePass}
                    onSubmitPhone={sendUpdatePhoneVerificationCode}
                    onSubmitCode={checkUpdatePhoneVerificationCode}
                    onUpdatePhone={updatePhone}
                    hideChangeButtons
                    canChangeOnlyPhone
                    disabled
                />
            ) : null}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    auth: state.auth.auth,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    updatePhone: dispatch.auth.updatePhoneAsync,
    changePassword: dispatch.auth.changePasswordAsync,
    sendUpdatePhoneVerificationCode: dispatch.auth.sendUpdatePhoneVerificationCodeAsync,
    checkUpdatePhoneVerificationCode: dispatch.auth.checkUpdatePhoneVerificationCodeAsync,
});

export default connect(mapState, mapDispatch)(ProfileContainer);

interface IChangePass {
    newPassword: string;
    oldPassword?: string;
    captcha?: string;
}

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
type Props = connectedProps;
